/**
 * Quality 模块枚举定义（自动生成）
 * 
 * ⚠️ 此文件由 api:export-types 命令自动生成
 * ⚠️ 请勿手动编辑！如需修改，请修改后端Model常量后重新生成
 * 
 * @generated 2025-12-04T05:00:10.271670Z
 * @generator api:export-types v1.0.0
 */

/**
 * AQLStandard级别
 */
export enum AQLStandardLEVEL {
  S1 = 'S-1',
  S2 = 'S-2',
  S3 = 'S-3',
  S4 = 'S-4',
  I = 'I',
  II = 'II',
  III = 'III',
}

/**
 * AQLStandard状态
 */
export enum AQLStandardSTATUS {
  DISABLED = 0,
  ENABLED = 1,
}

/**
 * InspectionItem类型
 */
export enum InspectionItemTYPE {
  DIMENSION = 'DIMENSION',
  VISUAL = 'VISUAL',
  FUNCTIONAL = 'FUNCTIONAL',
  WEIGHT = 'WEIGHT',
  HARDNESS = 'HARDNESS',
  TENSILE = 'TENSILE',
  APPEARANCE = 'APPEARANCE',
  PACKAGING = 'PACKAGING',
  OTHER = 'OTHER',
}

/**
 * InspectionItemVALUE
 */
export enum InspectionItemVALUE {
  TYPE_NUMERIC = 'NUMERIC',
  TYPE_BOOLEAN = 'BOOLEAN',
  TYPE_TEXT = 'TEXT',
  TYPE_OPTION = 'OPTION',
}

/**
 * InspectionItem状态
 */
export enum InspectionItemSTATUS {
  ENABLED = 1,
  DISABLED = 0,
}

/**
 * InspectionRecordRESULT
 */
export enum InspectionRecordRESULT {
  QUALIFIED = 'QUALIFIED',
  REJECTED = 'REJECTED',
}

/**
 * InspectionTask类型
 */
export enum InspectionTaskTYPE {
  IQC = 'IQC',
  IPQC = 'IPQC',
  OQC = 'OQC',
  SELF = 'SELF',
  PATROL = 'PATROL',
  FIRST_ARTICLE = 'FIRST_ARTICLE',
  RECHECK = 'RECHECK',
}

/**
 * InspectionTaskSOURCE
 */
export enum InspectionTaskSOURCE {
  RECEIVING = 'RECEIVING',
  WORK_ORDER = 'WORK_ORDER',
  WORK_REPORT = 'WORK_REPORT',
  PRODUCTION_BATCH = 'PRODUCTION_BATCH',
  MANUAL = 'MANUAL',
}

/**
 * InspectionTask状态
 */
export enum InspectionTaskSTATUS {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

/**
 * InspectionTaskRESULT
 */
export enum InspectionTaskRESULT {
  QUALIFIED = 'QUALIFIED',
  REJECTED = 'REJECTED',
  CONDITIONAL = 'CONDITIONAL',
}

/**
 * InspectionTemplate类型
 */
export enum InspectionTemplateTYPE {
  IQC = 'IQC',
  IPQC = 'IPQC',
  OQC = 'OQC',
  SELF = 'SELF',
  PATROL = 'PATROL',
  FIRST_ARTICLE = 'FIRST_ARTICLE',
}

/**
 * InspectionTemplateSAMPLING - 抽样类型
 */
export enum InspectionTemplateSAMPLING {
  /** 全检 */
  FULL = 'FULL',
  /** 固定数量抽检 */
  SAMPLING = 'SAMPLING',
  /** 固定数量抽检（兼容别名） */
  FIXED = 'SAMPLING',
  /** AQL 抽样 */
  AQL = 'AQL',
  /** 首件 */
  FIRST_ARTICLE = 'FIRST_ARTICLE',
  /** 免检 */
  SKIP = 'SKIP',
}

/**
 * InspectionTemplate状态
 */
export enum InspectionTemplateSTATUS {
  ENABLED = 1,
  DISABLED = 0,
}

/**
 * NCRLogACTION
 */
export enum NCRLogACTION {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  SUBMIT = 'SUBMIT',
  CONFIRM = 'CONFIRM',
  ASSIGN = 'ASSIGN',
  SUBMIT_DISPOSITION = 'SUBMIT_DISPOSITION',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  EXECUTE = 'EXECUTE',
  EXECUTE_FAILED = 'EXECUTE_FAILED',
  CLOSE = 'CLOSE',
  CANCEL = 'CANCEL',
  REOPEN = 'REOPEN',
  ADD_REMARK = 'ADD_REMARK',
  UPLOAD_ATTACHMENT = 'UPLOAD_ATTACHMENT',
}

/**
 * NCROrderSOURCE
 */
export enum NCROrderSOURCE {
  IQC = 'IQC',
  IPQC = 'IPQC',
  OQC = 'OQC',
  SELF = 'SELF',
  PATROL = 'PATROL',
  FIRST_ARTICLE = 'FIRST_ARTICLE',
  CUSTOMER = 'CUSTOMER',
  LPA = 'LPA',
  OTHER = 'OTHER',
}

/**
 * NCROrder级别
 */
export enum NCROrderLEVEL {
  CRITICAL = 'CRITICAL',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
}

/**
 * NCROrderDISPOSITION
 */
export enum NCROrderDISPOSITION {
  SCRAP = 'SCRAP',
  REWORK = 'REWORK',
  RETURN = 'RETURN',
  CONCESSION = 'CONCESSION',
  DOWNGRADE = 'DOWNGRADE',
  USE_AS_IS = 'USE_AS_IS',
  SORT = 'SORT',
}

/**
 * NCROrder状态
 */
export enum NCROrderSTATUS {
  DRAFT = 'DRAFT',
  PENDING_CONFIRM = 'PENDING_CONFIRM',
  PENDING_REVIEW = 'PENDING_REVIEW',
  REVIEWING = 'REVIEWING',
  PROCESSING = 'PROCESSING',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  EXECUTED = 'EXECUTED',
  EXECUTION_FAILED = 'EXECUTION_FAILED',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
  // 兼容别名
  PENDING = 'DRAFT',
}

/**
 * SelfInspectionConfigFREQ
 */
export enum SelfInspectionConfigFREQ {
  BY_TIME = 'TIME',
  BY_QUANTITY = 'QUANTITY',
  BY_BATCH = 'BATCH',
}

/**
 * SelfInspectionConfig单位
 */
export enum SelfInspectionConfigUNIT {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  SHIFT = 'SHIFT',
}

/**
 * SelfInspectionConfig状态
 */
export enum SelfInspectionConfigSTATUS {
  DISABLED = 0,
  ENABLED = 1,
}

